import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=5cd4ce3e&scoped=true&"
import script from "./InquiryList.vue?vue&type=script&lang=js&"
export * from "./InquiryList.vue?vue&type=script&lang=js&"
import style0 from "./InquiryList.vue?vue&type=style&index=0&id=5cd4ce3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd4ce3e",
  null
  
)

export default component.exports